import { SOCKET } from '@/helpers/Constants';

export default {
  data() {
    return {
      socket: null as WebSocket | null,
      closed: false
    };
  },
  methods: {
    /**
     * just give the base url
     */
    defaultAppUrl() {
      return SOCKET;
    },
    /**
     *
     * @param {string} handler this should be the same name as at the backend side
     * @param {string} query params
     * @param {string} url which can use for connection
     */
    checkAliveSocket(this: any, handler: string, query?: string, url: string = ""): void {
      this.socket.send(JSON.stringify({
        toSocketId: {
          mallId: `main`,
          stationId: `main`
        },
        fromSocketId: {
          mallId: `main`,
          stationId: `main`
        },
        message: 'test'
      }));
      if (!this.isOpen(this.socket)) {
        if (this.socket.readyState === this.socket.CLOSED) {
          if (navigator.onLine) {
            this.connectSocket(handler, query, url);
          }
        } else {
          if (!this.closed) {
            this.closeSocket();
          }
        }
      }
    },
    /**
     *
     * @param {Event} event error event
     */
    onSocketError(this: any, event: Event): void {
      console.log("error: " + event);
    },
    /**
     *
     * @param {Event} event close event
     */
    onCloseSocket(this: any, event: CloseEvent): void {
      this.closed = true;
      console.log("closed connection from " + event);
    },
    /**
     * close socket
     */
    closeSocket(this: any, ) {
      if (this.socket && this.socket.readyState !== this.socket.CLOSED) {
        this.socket.close(1000, "Closing from client");
      }
      this.closed = true;
    },
    /**
     *
     * @param {string} handler this should be the same name as at the backend side
     * @param {string} query params
     * @param {string} url which can use for connection
     */
    connect(this: any, handler: string, query?: string, url = ""): void {
      if (!this.isOpen(this.socket)) {
        this.connectSocket(handler, query, url);
      }
    },
    /**
     *
     * @param {WebSocket} ws check if WebSocket is already open
     */
    isOpen(this: any, ws: WebSocket | null): boolean {
      if (ws) {
        return ws.readyState === ws.OPEN;
      }
      return false;
    },
    /**
     *
     * @param {string} handler this should be the same name as at the backend side
     * @param {string} query params
     * @param {string} url which can use for connection
     */
    connectSocket(this: any, handler: string, query?: string, url = ""): void {
      const self = this;
      const uri = url !== "" ? url : this.defaultAppUrl();
      this.socket = new WebSocket(
        `${uri}/${handler}${query ? "?" + query : ""}`
      );
      this.socket.onopen = function(event) {
        if (self.onOpenSocket) {
          self.onOpenSocket(event);
        }
      };
      this.socket.onclose = function(event) {
        if (self.onCloseSocket) {
          self.onCloseSocket(event);
        }
      };
      this.socket.onmessage = function(event) {
        if (self.onSocketMessage) {
          self.onSocketMessage(event);
        }
      };
      self.socket.onerror = function(event) {
        if (self.onSocketError) {
          self.onSocketError(event);
        }
      };
    },
    /**
     *
     * @param {string} message send a message to the server
     */
    socketSend(this: any, message: string): void {
      this.socket.send(message);
    }
  }
};
